export const environment = {
  production: true,
  name: 'prod',
  serviceBaseUrls: {
    DOMAIN01: 'https://apis.bajajfinservmarkets.in/app01',
    DOMAIN02: 'https://bajajfinservmarkets.in/',
    DOMAIN03: 'https://apis.bajajfinservmarkets.in/app01',
    DOMAIN04: 'https://apis.bajajfinservmarkets.in/app01/',
    AEMURL: 'https://www.bajajfinservmarkets.in'
  },
  IMAGES: {
    "desLoader":"https://bfsd.uat.bfsgodirect.com/content/dam/bajajfinserv/spa-banners/lending-page-loader-/BMarkets_LOANS_MultipleUSP_Updated.gif",
    "mobLoader":"https://bfsd.uat.bfsgodirect.com/content/dam/bajajfinserv/spa-banners/lending-page-loader-/BMarkets_LOANS_MOBILE_MultipleUSP.GIF",
    "bankLogoUrl":"https://www.bajajfinservmarkets.in/api/assets/bajajfinserv/creditcardcontentfragments/"
  },
  endPoints: {},
  hmr: true,
  adobeAnalytics:"//assets.adobedtm.com/5fc97671c230/cd5e6eefeb83/launch-d736f0244252.min.js",
  adobefinvuScript:'//assets.adobedtm.com/5fc97671c230/cd5e6eefeb83/launch-d736f0244252.min.js'
};

